'use strict'

$(function(){

  // HOME
  if( $("body").is("#disc") ){

    $.fn.extend({
      get_filesize: function(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.open("HEAD", url, true);
        xhr.onreadystatechange = function() {
            if (this.readyState == this.DONE) {
                callback(parseInt(xhr.getResponseHeader("Content-Length")));
            }
        };
        xhr.send();
      }
    });

    $(".js-get-filesize li") .each(function(){
      var $t = $(this);
      var pdf = $("a", this).attr("href");
      $.fn.get_filesize(pdf, function(size) {
        size = size.bytes();
        $(".filesize", $t).text(size);
      });
    });

  }
});



// WEBPACK FOOTER //
// ./_src/js/cont/disc.js